import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { initializeNavigationAnalytics } from "@/shared/utils/analytics/analytics-secondary-nav";
import { GamesAnalytics } from "./analytics/analytics-games";
import { useCardsGridCarousel } from "./composables/use-cards-grid-carousel";
import { useGameEffects } from "./composables/use-game-effects";

const initEffects = () => {
    const isDesktop = useBreakpoints("sm2");
    if (isDesktop.value) {
        //TODO - completelely remove ripple effect
        const buttons = Array.from(document.querySelectorAll(".games-button")) as HTMLElement[];
        const gameCards = Array.from(document.querySelectorAll(".games-card-game")) as HTMLElement[];
        const winCards = Array.from(document.querySelectorAll(".games-card-win")) as HTMLElement[];
        const gameBonuses = Array.from(document.querySelectorAll(".games-bonus")) as HTMLElement[];

        const { setupEffects: setupCardEffects } = useGameEffects(gameCards, () => isDesktop.value);
        const { setupEffects: setupWinEffects } = useGameEffects(winCards, () => isDesktop.value);
        const { setupEffects: setupButtonEffects } = useGameEffects(buttons, () => isDesktop.value);
        const { setupEffects: setupBonusEffects } = useGameEffects(gameBonuses, () => isDesktop.value);

        setupCardEffects();
        setupBonusEffects();
        setupWinEffects(20, 25);
        setupButtonEffects();
    }
};

const initCarousels = () => {
    useCardsGridCarousel();
};

const initAnalytics = () => {
    GamesAnalytics.pushGamesPage();
    GamesAnalytics.initBonusAnalytics();
    GamesAnalytics.initCasinoArticlesAnalytics();
    initializeNavigationAnalytics();
};

document.ready(() => {
    initEffects();
    initCarousels();
    initAnalytics();
});
